import { useCallback, useEffect } from 'react';
import { useRouter, useSearch } from '@tanstack/react-router';
import { WriteOffQueuePage } from '../../features/writeoff/ui/WriteOffQueuePage.js';
import {
  searchOfTab,
  tabFromSearchValue,
  type WriteOffTab,
} from '../../features/writeoff/model/write-off-tabs.js';

export const WRITE_OFFS_PATH = '/write-offs';

const hrefOfTab = (tab: WriteOffTab): string => {
  const { status } = searchOfTab(tab);
  return status === undefined ? WRITE_OFFS_PATH : `${WRITE_OFFS_PATH}?status=${status}`;
};

/**
 * Navbat sahifasining marshrut o'rami — faol tab MANZILDA turadi
 * (`/write-offs?status=rejected`), ya'ni yangilash uni yo'qotmaydi va
 * tabga havola berish mumkin.
 *
 * Sukutdagi tab — «Hammasi»: sidebar havolasi toza `/write-offs` va u
 * shunda ochiladi. Eski `?tab=pending` kaliti ham o'qiladi
 * (`parseWriteOffsSearch`) va `?status=pending` ga aylantiriladi.
 *
 * Eski yoki noto'g'ri havola (`?status=cancelled`, `?status=abc`) sahifani
 * buzmaydi: tab `tabFromSearchValue` bilan tanlanadi va manzil BIR MARTA,
 * tarixga yozuv qo'shmasdan to'g'rilanadi.
 *
 * Manzil `navigate({ search })` bilan emas, `history.replace` bilan va
 * QO'LDA quriladi: router tasdiqlangan qidiruvni xomining USTIGA qo'yadi,
 * ya'ni `{}` qaytganda xom `status=abc` o'zgarmay qolardi va sukutdagi
 * tabga qaytish manzilni tozalamasdi.
 */
export const WriteOffsRoute = () => {
  const router = useRouter();
  const search = useSearch({ from: '/shell/write-offs' });
  const tab = tabFromSearchValue(search.status);

  const showTab = useCallback(
    (next: WriteOffTab): void => {
      const href = hrefOfTab(next);
      if (`${window.location.pathname}${window.location.search}` !== href) {
        router.history.replace(href);
      }
    },
    [router],
  );

  useEffect(() => showTab(tab), [showTab, tab, search.status]);

  return <WriteOffQueuePage tab={tab} onTabChange={showTab} />;
};
